import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `api-keys.lazy.tsx`. No search
// params today — the page is a self-contained list + create/rotate/revoke
// surface. If we add a `?focus=<id>` deep-link later for audit-log
// cross-references, that's where it goes.
export const Route = createFileRoute("/app/settings/api-keys")({});
